import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function NavContent({ isNavExpanded, selectedComponent, onCollapse, isWorkspaceExpanded }) {
  return (
    <div
      className={
        classNames(
          'nav-content',
          { 'nav-content--open': isNavExpanded },
          { 'nav-content--workspace-open': isWorkspaceExpanded }
        )
      }
    >
      <i onClick={onCollapse} className="nav-content__back-icon" />
      {selectedComponent}
    </div>
  );
}

NavContent.propTypes = {
  isNavExpanded: PropTypes.bool,
  selectedComponent: PropTypes.element,
  onCollapse: PropTypes.func,
  isWorkspaceExpanded: PropTypes.bool,
};

export default NavContent;
